import { render, staticRenderFns } from "./new-home-types.vue?vue&type=template&id=3cb59b80&scoped=true&"
import script from "./new-home-types.vue?vue&type=script&lang=js&"
export * from "./new-home-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb59b80",
  null
  
)

export default component.exports